import * as actionTypes from "./actionTypes"

export const setData = (data) => {
  return { type: actionTypes.SET_DATA, payload: { ...data } }
}

export const clearData = () => {
  return { type: actionTypes.CLEAR_DATA, payload: {} }
}
